import gsap from "gsap";

const filters = document.querySelectorAll('.product-categories__category-list__section');
const eventFilters = document.querySelectorAll('.events-list-block__category-item');

const setActive = (item) => {
    if (item.classList.contains('active')) {
        gsap.to(item.children[1], { duration: 0.3, height: 0 });
        item.classList.remove('active');
    } else {
        [...item.parentElement.children].forEach((sib) => {
            gsap.to(sib.children[1], { duration: 0.3, height: 0 });
            sib.classList.remove('active');
        });
        gsap.to(item.children[1], { duration: 0.3, height: 'auto' });
        item.classList.toggle('active');
    }
}


if (filters) {
    filters.forEach(filter => {
        filter.querySelectorAll('.title').forEach(item => {
            item.addEventListener('click', () => {
                const itemParent = item.parentElement;
                setActive(itemParent);
            });
        });
    });

    document.querySelectorAll('.product-categories__category-list__section__item').forEach(item => {
        const itemChildList = item.querySelector('.product-categories__category-list__section__item-list');
        if (!itemChildList) return;
        const itemSVG = item.querySelector('.product-cat-label svg');
        itemSVG.addEventListener('click', () => {
            item.classList.toggle('active');
            if (item.classList.contains('active')) {
                gsap.to(itemChildList, { duration: 0.3, height: 'auto' });
            } else {
                gsap.to(itemChildList, { duration: 0.3, height: 0 });
            }
        });
    });
}

// if(eventFilters) {
//     eventFilters.forEach(filter => {
//         filter.addEventListener('click', (e) => {
//             filter.classList.toggle('active');
//         });
//     });
// }

const mobileFilterButton = document.querySelector('.mobile-filter-button');
const mobileFilterClose = document.querySelector('.product-categories__category-list.mobile-only .mobile-close ');

if (mobileFilterButton) {
    mobileFilterButton.addEventListener('click', () => {
        const filter = document.querySelector('.product-categories__category-list.mobile-only');
        filter.classList.toggle('visible');
    });
}

if (mobileFilterClose) {
    mobileFilterClose.addEventListener('click', () => {
        const filter = document.querySelector('.product-categories__category-list.mobile-only');
        filter.classList.remove('visible');
    });
}